export enum ActionMagnetFlowEnum {
  ONLY_JOURNAL,
  CONTR_VAL,
}
